import _objectSpread from "@babel/runtime/helpers/objectSpread2";
export default function fitHorizontally(position, context) {
  var isWithinWindow = context.isWithinWindow,
      targetMarginInlineStart = context.targetMarginInlineStart,
      targetMarginInlineEnd = context.targetMarginInlineEnd,
      targetWidth = context.targetWidth,
      withinLeft = context.withinLeft,
      withinScrollLeft = context.withinScrollLeft,
      withinWidth = context.withinWidth;
  var withinOffset = isWithinWindow ? withinScrollLeft : withinLeft;
  var collisionWidth = targetWidth + targetMarginInlineStart + targetMarginInlineEnd;
  var collisionPositionLeft = position.left - targetMarginInlineStart;
  var overLeft = withinOffset - collisionPositionLeft;
  var overRight = collisionPositionLeft + collisionWidth - withinWidth - withinOffset;
  var newPositionLeft = position.left;
  var newOverRight; // The target element is wider than within element.

  if (collisionWidth > withinWidth) {
    // The target element is initially over the left side of within element.
    if (overLeft > 0 && overRight <= 0) {
      newOverRight = position.left + overLeft + collisionWidth - withinWidth - withinOffset;
      newPositionLeft += overRight - newOverRight; // The target element is initially over right side of within element.
    } else if (overRight > 0 && overLeft <= 0) {
      newPositionLeft = withinOffset; // The target element is initially over both left and right sides of within.
    } else if (overLeft > overRight) {
      newPositionLeft = withinOffset + withinWidth - collisionWidth;
    } else {
      newPositionLeft = withinOffset;
    } // The target element is too far left, align with left of within element.

  } else if (overLeft > 0) {
    newPositionLeft += overLeft; // The target element is too far right, align with right of offset container.
  } else if (overRight > 0) {
    newPositionLeft -= overRight; // Adjust based on position and margin
  } else {
    newPositionLeft = Math.max(position.left - collisionPositionLeft, position.left);
  }

  return _objectSpread(_objectSpread({}, position), {}, {
    left: newPositionLeft
  });
}